'use client';

import Navbar from '@/components/matar/navbar';
import Hero from '@/components/matar/hero';
import ValuesStrip from '@/components/matar/values-strip';
import Atelier from '@/components/matar/atelier';
import AboutPage from '@/components/matar/about-page';
import PrestigiousProducts from '@/components/matar/prestigious-products';
import Shop from '@/components/matar/shop';
import GalleryAll from '@/components/matar/gallery-all';
import Craft from '@/components/matar/craft';
import Traceability from '@/components/matar/traceability';
import SurMesure from '@/components/matar/sur-mesure';
import Maison from '@/components/matar/maison';
import Heritage from '@/components/matar/heritage';
import UsineSolaire from '@/components/matar/usine-solaire';
import Distinctions from '@/components/matar/distinctions';
import Testimonials from '@/components/matar/testimonials';
import Blog from '@/components/matar/blog';
import Boutique from '@/components/matar/boutique';
import FAQ from '@/components/matar/faq';
import SurInvitation from '@/components/matar/sur-invitation';
import Contact from '@/components/matar/contact';
import Footer from '@/components/matar/footer';
import FloatingCTA from '@/components/matar/floating-cta';
import CartDrawer from '@/components/matar/cart-drawer';
import WishlistDrawer from '@/components/matar/wishlist-drawer';
import CheckoutModal from '@/components/matar/checkout-modal';
import CompareModal from '@/components/matar/compare-modal';
import AuthModal from '@/components/matar/auth-modal';

export default function Home() {
  return (
    <div className="relative min-h-screen flex flex-col bg-[#0a0a0f]">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <ValuesStrip />
        <Atelier />
        <AboutPage />
        <PrestigiousProducts />
        <Shop />
        <GalleryAll />
        <Craft />
        <Traceability />
        <SurMesure />
        <Maison />
        <Heritage />
        <UsineSolaire />
        <Distinctions />
        <Testimonials />
        <Blog />
        <Boutique />
        <FAQ />
        <SurInvitation />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
      <CartDrawer />
      <WishlistDrawer />
      <CheckoutModal />
      <CompareModal />
      <AuthModal />
    </div>
  );
}
